<div>
  @if (busy) {
    <div class="overlay">
      <div class="center">
        <mat-spinner>
        </mat-spinner>
      </div>
    </div>
  }
  <mat-card-content>
    <div class="flex-col justify-center items-center w-100 my-2">
      <span class="amount">Authorize {{amountToAuthorize | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
      <!-- Display a payment form -->
      @if (!paymentIntent) {
        <form id="payment-form" class="w-100 mt-3">
          <div id="payment-element">
            <!--Stripe.js injects the Payment Element-->
          </div>
          <div class="flex-row space-between items-center w-100 mt-3">
            <button id="submit" mat-flat-button class="w-100" color="primary" >
              <div class="spinner hidden" id="spinner"></div>
              <span id="button-text">Authorize now</span>
            </button>
          </div>
          <div id="card-errors"></div>
        </form>
      }
      @if (stripeMessage) {
        <div class="mt-3 warn-color">{{stripeMessage}}</div>
      }
      @if (paymentIntent) {
        <div class="w-100 mt-3">
          Authorization Successful.
        </div>
      }
      @else {
        <div class="w-100 mt-3">
          <span> By selecting 'Authorize now' you agree your card being authorized for the stated amount. We will not capture the charge at this stage.</span>
        </div>
      }
    </div>
  </mat-card-content>
</div>